import { PricingTeaserComponent } from './PricingTeaserComponent';

export function PricingTeaserComponentC(
  props: React.ComponentProps<typeof PricingTeaserComponent>,
) {
  return <PricingTeaserComponent {...props} />;
}
